import IDocument from "../../../types/IDocument";
import IDocumentStorageService, { IProgressCallback, IUploadSuccess, IUploadError } from "../../spi/IDocumentStorageService";
import FirebaseService from '../firebase/FirebaseService';
import { getCurrentTenant } from '../../../configs/dbConfigs' 
import ITenant from "../../../types/ITenant";

const TENANT:ITenant = getCurrentTenant();

export default class GcpStorageService implements IDocumentStorageService {
    client: any;
    readonly tenantId:string;
    publicStorageBucket: string = "doc-library-output";

    private static service: GcpStorageService;
    private constructor() {
        this.client = FirebaseService.getInstance()
        //get the tenant
        this.tenantId = TENANT.tenantId;
    }

    static getInstance(): GcpStorageService {
        if (this.service == null) {
            this.service = new GcpStorageService();
        }
        return this.service;
    }

    uploadDocument(file: any, metadata: any, doc: IDocument, progress: IProgressCallback, success: IUploadSuccess, error: IUploadError) {
        let regx = file.name.match(/[.]\w+/i);
        if (doc.who.owner.uid) {
            let file_name = encodeURIComponent(doc.who.owner.uid.substr(-5) + file.name.substring(0, regx.index))
            /*if (doc.file.docUrl !== null && doc.file.docUrl !== ""){
                //this.deleteDocument(doc.docUrl, metadata)  ---- WHY ??
            }*/

            try {
                let storageRef = FirebaseService.getInstance().storageRef();
                const mdata = {
                    customMetadata: metadata
                }
                let dest_file_name = doc.who.owner.uid.substr(-5) + file.name
                const uploadTask = storageRef.child(dest_file_name).put(file, mdata);

                uploadTask.on('state_changed', (snapshot: any) => {
                    progress(snapshot);
                }, (error: any) => {
                    switch (error.code) {
                        case 'storage/unauthorized':
                            error('Unauthorized to upload document')
                            break;
                        case 'storage/canceled':
                            error('Upload cancelled')
                            break;
                        case 'storage/unknown':
                            error('Unknown error occured while uploading document.')
                            break;
                    }
                }, () => {
                    try {
                        if (doc.file) {
                            storageRef.child(dest_file_name).getDownloadURL().then((url: string) => {
                                doc.file.docUrl = url;
                                doc.file.thumbUrl = this._getPageUrl(doc.file.thumbPageNo, file_name);
                                //now the slides
                                if (doc.file.noOfPages > 0) {
                                    let pages = [];
                                    for (var i = 0; i < doc.file.noOfPages; i++) {
                                        pages.push({ id: i + 1, url: this._getPageUrl(i + 1, file_name) });
                                    }
                                    doc.file.pages = pages;
                                } 
                                success(doc);
                            });
                        }
                    } catch (e) {
                        throw e;
                    }
                });
            } catch (e) {
                debugger;
                throw e;
            }
        }
    }

    async deleteDocument(docUrl: string, metadata: any): Promise<Boolean> {
        try {
            let storageRef = FirebaseService.getInstance().storageRefFromURL(docUrl);
            let mdata = {
                customMetadata: {
                    'refId': 'NA',
                    'deleteMerker': 'true'
                }
            }

            let x = FirebaseService.getInstance().storageRef();
            try {
                let y = await x.child(storageRef.fullPath).updateMetadata(mdata);
            }
            catch (e) {
                console.log(e);
            }
        }
        catch (ex) {
            console.log('error Occurred', ex);
        }
        return true;
    }

    _getPageUrl = (pageNo: number, fileName: string) => {
        return "https://storage.googleapis.com/" + this.publicStorageBucket + "/tenant_" + this.tenantId + "/" + fileName + "/" + fileName + "-" + pageNo + ".png";
    }
}